import * as React from "react";
import { List, Datagrid, TextField, NumberField } from "react-admin";
import { FrDateField } from "../../components/FrDateField";
import { BookingRefField } from "../../components/ui";

// Ledger des gains d'affiliation (GET /admin/affiliation-transactions).
export default {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }} perPage={50} title="Transactions d'affiliation">
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <TextField source="beneficiary" label="Bénéficiaire" />
        <NumberField locales="fr-FR" source="amount" label="Montant (€)" options={{ style: "currency", currency: "EUR" }} />
        <BookingRefField source="bookingId" label="Rendez-vous" />
        <TextField source="description" />
        <FrDateField source="createdAt" label="Date" showTime />
      </Datagrid>
    </List>
  ),
};
